
define('eteration/ui/base-viewmodel',['jquery',
        'knockout',
        'moment',
        'eteration/eteration-i18n',
        'eteration/widgets/ui-date-formats',
        'eteration/eteration-base',
        'eteration/eteration-ajax',
        'ui-helper/cookie-helper',
        'ui-helper/gtm-helper',
        'eteration/widgets/ui-i18n','eteration/widgets/ui-img'], 
function($,ko,moment,i18n,dateFormats,Eteration,etrAjax,cookieHelper,gtmHelper) {

	function BaseViewModel() {
		var self = this;
		
		self.geti18nText = function(key){
			return i18n.get(key);
		};

		self.suggestedLocation = ko.observable();
		
		self.allowPageChangeWithoutClearTerminal= function() { };
		
		self.formatTimeWithEnglishLocalMoment = function(time, timeFormat){
			
			var localMoment = moment;
			var oldLocaleCode = localMoment.locale();
			localMoment.locale('en');
			
			var timeLimitOptionAmPm = localMoment.utc(time).format(timeFormat).toUpperCase();
			
			localMoment.locale(oldLocaleCode);
			
			return timeLimitOptionAmPm;
		}
		
		self.language =  ko.observable(i18n.getUserLocale());
		
		self.dateFormat =  function(){
			var userLocale = i18n.getUserLocale();
			var dateFormat = dateFormats[userLocale];
			return dateFormat;
		};

		self.renderReady =  ko.observable(false);

		self.initFragments = function(vm, module, app, single, idKey) {
			self.initFragmentsViaTemplate(vm, module, module, app, single, idKey)
		};
		self.initFragmentsViaTemplate = function(vm, module, template, app, single, idKey) {
			if(single) {
				var suffix = $(window).width() >= 768 ? '_web':'_mobile';
				var tpl = template + suffix;
				var elementIdKey = idKey ? idKey : module + '_container';
				loadFragment(vm, module, tpl, app, elementIdKey)
			} else {
				$.each(['_web', '_mobile'], function(i, suffix){
					var tpl = template + suffix;
					var elementIdKey = idKey ? idKey : tpl;
					loadFragment(vm, module, tpl, app, elementIdKey)
				});
			}
		};
		function loadFragment(vm, module, template, app, idKey){
			Eteration.loadStaticFragment({
				module : module,
				app : app,
				tmpl : template,
				el : $('#'+idKey),
				success : function() {
					ko.applyBindings(vm, $('#' + idKey)[0]);
				}
			});
		}
		
		function setBrowserIE() {
			var ua = window.navigator.userAgent;
			var msie = ua.indexOf("MSIE ");
			var trident = ua.indexOf('Trident/');
    		window.browserIE = ((msie > 0 || trident > 0) ? true : false);
		}
		setBrowserIE();
		
		self.browserIE = ko.observable(window.browserIE);
		
		function setDeviceTypeByWidth() {
			var wWidth = $(window).width();
			
			window.isMobile = (wWidth < 992);
			
			window.isDesktop = (wWidth >= 992);
			window.isTablet = (wWidth < 992) && (wWidth >= 768);
			window.isPhone = (wWidth < 768);
			window.isPhoneOrTablet = (wWidth < 992);
		};
		setDeviceTypeByWidth();
		
		self.isMobile = ko.observable(window.isPhoneOrTablet || $(window).width() < 992);
		
		self.isAndroid = function() {
			return getMobileOperatingSystem() == "Android";
		};
		self.isIOS = function() {
			return getMobileOperatingSystem() == "iOS";
		};
		self.isWindowsMobile = function() {
			return getMobileOperatingSystem() == "Windows";
		};
		self.getPhoneDeviceType = function() {
			return getMobileOperatingSystem();
		};

		function getMobileOperatingSystem() {
			var userAgent = navigator.userAgent || navigator.vendor || window.opera;

			setDeviceTypeByWidth();

			if (/iPad|iPhone|iPod/i.test(userAgent)) {
				return 'iOS';
			} else if (/Android/i.test(userAgent)) {
				return 'Android';
			} else if (/Windows Phone|Windows Mobile|IEMobile|Windows/i.test(userAgent)) {
				return 'Windows';
			} else if (/Huawei|HuaweiBrowser|HMSCore/i.test(userAgent) ||
				/\b(lya-|vog-|ane-|ele-|clt-|bla-|eva-|eml-|nem-|par-)[a-z0-9]+/i.test(userAgent)) {
				return 'Huawei';
			} else {
				return 'unknown';
			}
		}
		
		var googleUtilactionMap  = {
			    "sendGtmParams" : function(params){
			            if(params.meta){
	            	        if(params.meta.language){
	            	            params.data.language = self.language();
	            	        }
	    	            }
			            gtmHelper.pushGenericPageData(params.data);
			    },
			    "sendPersistables"  : function(params){
			         var key = params.key;
			         var products   = params.products;
			        if(products){
			            gtmHelper.sessionStorageUtil.sendPersistables(key,products)
			        }
			        else{
			             gtmHelper.sessionStorageUtil.sendPersistables(key);
			        }
			        
			    },
			    "clearPersistables" : function(key){
			        gtmHelper.sessionStorageUtil.clearPersistables(key)
			    },
			    "persistData" : function(params){
			    	var key = params.key;
			    	var products  = params.products;
			    	if(key&&products){
			    		gtmHelper.sessionStorageUtil.persistData(key,products);
			    	}
			    },
			    "pushEvent" : function(params){
			    	var event = params.event;
			    	if(event){
			    		gtmHelper.pushEvent(event);
			    	}
			    }
			};
			
		    self.googleUtil = function(action,params){
	    	    if(typeof googleUtilactionMap[action]=="function"){
	    	        googleUtilactionMap[action].call(self,params);
	    	    } 
		    };
	}

	if (!window.console) {
		window.console = {};
	}//ie9 console error fix
	if (!console.log) {
		console.log = function() {};
	}//ie9 console error fix
	
	
	return { BaseViewModel: BaseViewModel};
});